export enum Flags {
  workflow_review = 'workflow_review',
  auto_invite = 'auto_invite',
  repcode_access = 'repcode_access',
  configurable_table_pages = 'configurable_table_pages',
  mackenzie_account_page = 'mackenzie_account_page',
  conditional_account_page_configuration = 'conditional_account_page_configuration',
  acb_rework = 'acb_rework',
  spanish_language_support = 'spanish_language_support',
  weekdays_only_calendar = 'weekdays_only_calendar',
  text_variants = 'text_variants',
  form_mapper = 'form_mapper',
  show_account_type = 'show_account_type',
  portfolio_trading_prototype = 'portfolio_trading_prototype',
  widgets_additional_info = 'widgets_additional_info',
  close_sub_account = 'close_sub_account',
  alert_banners = 'alert_banners',
  asset_class_portfolios = 'asset_class_portfolios',
  audit_log_widget_v2 = 'audit_log_widget_v2',
  bulk_trader_revamp = 'bulk_trader_revamp',
  bulk_rebalance = 'bulk_rebalance',
  docusign_in_app_signing = 'docusign_in_app_signing',
  recon_flags_dashboard = 'recon_flags_dashboard',
  recon_activities_dashboard = 'recon_activities_dashboard',
  recon_tolerance_config = 'recon_tolerance_config',
  household_portfolio = 'household_portfolio',
  household_portfolio_allocation_methodology = 'household_portfolio_allocation_methodology',
  household_model_portfolio_widget = 'household_model_portfolio_widget',
  household_portfolio_customized_allocations_workflow = 'household_portfolio_customized_allocations_workflow',
  forms_idempotent_form_steps = 'forms_idempotent_form_steps',
  form_completion_reupload_overwrite = 'form_completion_reupload_overwrite',
  use_fee_enable_toggle = 'use_fee_enable_toggle',
  use_improved_sales_tax = 'use_improved_sales_tax',
  home_page_product_aum_exposure = 'home_page_product_aum_exposure',
  tcp_spouse_lookup = 'tcp_spouse_lookup',
  workflow_household_branch_conditions = 'workflow_household_branch_conditions',
  workflow_sub_account_branch_conditions = 'workflow_sub_account_branch_conditions',
  resp_transferred_from_another_institution = 'resp_transferred_from_another_institution',
  preview_pdf_forms = 'preview_pdf_forms',
  mackenzie_release_3 = 'mackenzie_release_3',
  siem_data_feed = 'siem_data_feed',
  advisor_contact_repcode = 'advisor_contact_repcode',
  withdrawal_net_gross = 'withdrawal_net_gross',
  news_and_insights_role_targeting = 'news_and_insights_role_targeting',
  multi_portfolio_deposit = 'multi_portfolio_deposit',
  context_aware_workflows = 'context_aware_workflows',
}
